import React from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
  IconButton,
  CircularProgress,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Refresh as RefreshIcon,
  Link as LinkIcon,
  LinkOff as LinkOffIcon,
  Message as MessageIcon,
} from '@mui/icons-material';
import SettingsRowShell from './SettingsRowShell';

const SlackRow = ({
  slackStatus,
  loadingSlack,
  onRefresh,
  onConnect,
  onDisconnect,
}) => {
  const statusChip = loadingSlack
    ? null
    : slackStatus.connected
      ? { label: `Connected — ${slackStatus.display_name || 'Slack User'}`, color: 'success' }
      : { label: 'Not Connected', color: 'warning' };

  return (
    <SettingsRowShell
      icon={<MessageIcon />}
      title="Slack Connection"
      description="Send direct messages and notifications as yourself"
      status={statusChip}
      loading={loadingSlack}
      actions={
        <IconButton onClick={onRefresh} disabled={loadingSlack} size="small">
          <RefreshIcon fontSize="small" />
        </IconButton>
      }
    >
      {loadingSlack ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box>
          {slackStatus.connected ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <CheckCircleIcon color="success" fontSize="small" />
              <Box>
                <Typography variant="body2" fontWeight="medium">
                  {slackStatus.display_name || 'Slack User'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  User ID: {slackStatus.user_id}
                </Typography>
              </Box>
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Connect your Slack account to send direct messages as yourself.
            </Typography>
          )}

          <Box sx={{ display: 'flex', gap: 1 }}>
            {slackStatus.connected ? (
              <>
                <Button variant="outlined" size="small" onClick={onConnect} startIcon={<RefreshIcon />}>
                  Re-authenticate
                </Button>
                <Button variant="outlined" color="error" size="small" onClick={onDisconnect} startIcon={<LinkOffIcon />}>
                  Disconnect
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                size="small"
                onClick={onConnect}
                startIcon={<LinkIcon />}
                disabled={!slackStatus.configured}
              >
                Connect Slack
              </Button>
            )}
          </Box>

          {!slackStatus.configured && (
            <Alert severity="warning" sx={{ mt: 2 }} icon={false}>
              Slack OAuth is not configured on the server.
            </Alert>
          )}
        </Box>
      )}
    </SettingsRowShell>
  );
};

export default SlackRow;
